<section class="club-page">
  <div class="club-hero">
    <p class="club-kicker">MOANANI CLUB</p>
    <h1 class="club-title">I GOT LOVE</h1>
    <p class="club-lead">
      Un espacio para quienes viven la marca de cerca. Drops, novedades y momentos Moanani antes que nadie.
    </p>
  </div>

  <div class="club-grid">
    <article class="club-card">
      <h2>Novedades primero</h2>
      <p>Entérate de colecciones y lanzamientos sin ruido innecesario.</p>
    </article>
    <article class="club-card">
      <h2>Comunidad soft</h2>
      <p>Forma parte del círculo cercano de Moanani en Lima y más allá.</p>
    </article>
    <article class="club-card">
      <h2>Solo lo esencial</h2>
      <p>Correo ocasional, sin spam. Cancela cuando quieras.</p>
    </article>
  </div>

  <div class="club-form-wrap">
    <h2 class="club-form-title">Únete al Club</h2>
    <p class="club-form-copy">Deja tu correo y recibe lo nuevo de Moanani.</p>
    <app-club-subscribe source="club" variant="page"></app-club-subscribe>
    <a routerLink="/shop" class="club-shop-link">Ir a la tienda →</a>
  </div>
</section>